export default __webpack_public_path__ + "static/media/faviconN.1effb563.svg";